import React from "react"
import { Message, Icon } from "semantic-ui-react"
import { NamespacesConsumer as I18n } from "react-i18next"
import passwordValidator from "password-validator"

export const validatepassword = password => {
	let type = []
	let checkAZ = password.match(/([A-Z])/g)
	let checkaz = password.match(/([a-z])/g)
	let check09 = password.match(/([0-9])/g)
	if (checkAZ !== null || checkaz !== null || check09 !== null) {
		if (checkAZ) {
			type.push("content1")
		}
		if (checkaz) {
			type.push("content2")
		}
		if (check09) {
			type.push("content3")
		}
		if (password.length >= 8) {
			type.push("content4")
		}
	}
	return type
}

export const correctBox = (isFocus, password) => {
	let type = validatepassword(password)
	if (isFocus) {
		let showContent = {
			content1: [`register.RegisterpasswordUppercase`, "A-Z"],
			content2: [`register.RegisterpasswordLowercase`, "a-z"],
			content3: [`register.Registerpasswordnumber`, "0-9"],
			content4: [`register.Registerpasswordcharacters`, ""]
		}
		// showContent.splice(type, 1);
		type.forEach(t => {
			delete showContent[t]
		})
		if (type.length >= 4) {
			return <div />
		}
		return (
			<I18n>
				{t => {
					return (
						<div>
							<Message negative size="mini">
								{Object.keys(showContent).map((s, i) => {
									let tmp = showContent[s]
									return (
										<div key={i}>
											<Icon name="x" /> {t(tmp[0])} {tmp[1]}
											<br />
										</div>
									)
								})}
							</Message>
						</div>
					)
				}}
			</I18n>
		)
	} else {
		return <div />
	}
}

export const warningpassword = (password, re_password) => {
	if (password !== re_password && re_password !== "") {
		return (
			<I18n>
				{tranlator => {
					return (
						<div>
							<Message negative size="mini">
								<Icon name="warning" />
								{tranlator("register.warning")}
							</Message>
						</div>
					)
				}}
			</I18n>
		)
	} else {
		return <div />
	}
}

export const schema = new passwordValidator()
	.is()
	.min(8)
	.is()
	.max(100)
	.has()
	.uppercase()
	.has()
	.lowercase()
	.has()
	.digits()
